import { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  AuraLayout,
  BodyCopy,
  Button,
  ElevatedCircle,
  Layout,
  PageTitle,
} from "lola-framework-ui-test";
import { ErrorIcon } from "lola-framework-ui-test/src/icons";
import { useStore } from "../../../store/globalState";
import { useCallbackUrl } from "../../../store/usePartnerStore";
import {
  flavorClassName,
} from "../../../constants";

/**
 * Session Expired Page
 * Displays when a user's session has expired (link expired or not found).
 * Always shows a button to return to the partner app using the callback URL.
 */
export const SessionExpiredPage = memo(() => {
  const { t } = useTranslation();
  const { theme } = useStore();
  const callbackUrl = useCallbackUrl();

  // Use whiteView like LandingPage for consistent styling
  const colorConfig = theme.whiteView;
  const {
    backgroundBtn,
    textColorBtn,
    dropzoneColors,
    title,
    bodyCopy,
    buttonShowIcon,
    buttonSize,
  } = colorConfig;

  const handleReturnToApp = () => {
    window.location.href = callbackUrl;
  };

  return (
    <AuraLayout colorConfig={colorConfig} className={flavorClassName}>
      <Layout.Content className="landing-section">
        <ElevatedCircle
          shadowVariant="inset"
        >
          <ErrorIcon size={35} colors={dropzoneColors} />
        </ElevatedCircle>
        <section className="landing-container">
          <PageTitle
            highlight={t("error.sessionExpired")}
            highlightColor={title}
            secudnary=""
            secudnaryColor={title}
          />
          <BodyCopy style={{ color: bodyCopy }}>
            {t("error.sessionExpiredMessage")}
          </BodyCopy>
        </section>
      </Layout.Content>
      <Layout.Footer>
        <section className="footer-section">
          <Button
            size={buttonSize ?? "small"}
            showIcon={buttonShowIcon}
            background={backgroundBtn}
            color={textColorBtn}
            onClick={handleReturnToApp}
          >
            {t("error.returnToApp")}
          </Button>
        </section>
      </Layout.Footer>
    </AuraLayout>
  );
});
